import {Injectable} from "@angular/core";
import {MatDialog} from "@angular/material/dialog";
import {
  DocumentTemplateTableComponentData
} from "@modules/document-template/components/document-template-table/document-template-table.component";
import {
  DocumentTemplateTableDialogComponent
} from "@modules/document-template/components/document-template-table-dialog/document-template-table-dialog.component";

@Injectable({
  providedIn: 'root'
})
export class DocumentTemplateService {
  constructor() {
  }
  openDocumentTemplateTableDialog(
    dialog: MatDialog,
    data: DocumentTemplateTableComponentData
  ) {
    return dialog.open<
      DocumentTemplateTableDialogComponent,
      DocumentTemplateTableComponentData>(DocumentTemplateTableDialogComponent, {
      data,
      width: '80vw',
      height: '90vh'
    })
  }
}
